import { createStore } from 'vuex'

export default createStore({
  state: {
    title: "农业执法系统"
  },
  getters: {
  },
  mutations: {
  },
  actions: {
  },
  modules: {
  }
})
